module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-65.5972f2e0.svg";